/*
 * @Description: 春雨 app 环境判断
 * @Date: 2020-06-03 11:14:40
 * @LastEditTime: 2022-10-31 11:37:17
 */

/* eslint-disable prefer-destructuring */
const ua = navigator.userAgent;
const detect = {};

const detectApp = () => {
  detect.app = {};

  const chunyuApp = ua.match(/Chunyu.+?\s*?([\d.]+)/); // 春雨APP(客户端/医生端)
  const chunyuyisheng = ua.match(/Chunyuyisheng\s*?[/]{0,1}\s*?([\d.]+)/); // 春雨医生
  const chunyuClinic = ua.match(/ChunyuClinic\s*?[/]{0,1}\s*?([\d.]+)/); // 春雨诊所
  const chunyuNews = ua.match(/ChunyuNews\s*?[/]{0,1}\s*?([\d.]+)/); // 春雨阅读
  const wechat = ua.match(/MicroMessenger\s*?[/]{0,1}\s*?([\d.]+)/); // 微信
  const weibo = ua.match(/Weibo/); // 微博

  if (chunyuApp) {
    detect.app.chunyuApp = chunyuApp[1];
  }
  if (chunyuyisheng) {
    detect.app.chunyuyisheng = chunyuyisheng[1];
  }
  if (chunyuClinic) {
    detect.app.chunyuClinic = chunyuClinic[1];
  }
  if (chunyuNews) {
    detect.app.chunyuyuedu = chunyuNews[1];
  }
  if (wechat) {
    detect.app.wechat = wechat[1];
  }
  if (weibo) {
    detect.app.weibo = true;
  }
};

/**
 * @description 判断当前是否在春雨APP(用户端/医生端)环境下
 * @return {Boolean} 判断结果
 */
const isFromCYAll = () => {
  if (!detect.app) {
    detectApp();
  }
  return !!detect.app.chunyuApp;
};
/**
 * @description 判断当前是否在春雨医生环境下
 * @return {Boolean} 判断结果
 */
const isFromCY = () => {
  if (!detect.app) {
    detectApp();
  }
  return !!detect.app.chunyuyisheng;
};
/**
 * @description 判断当前是否在春雨诊所环境下
 * @return {Boolean} 判断结果
 */
const isFromCYClinic = () => {
  if (!detect.app) {
    detectApp();
  }
  return !!detect.app.chunyuClinic;
};
/**
 * @description 判断当前是否在春雨悦读环境下
 * @return {Boolean} 判断结果
 */
const isFromCYNews = () => {
  if (!detect.app) {
    detectApp();
  }
  return !!detect.app.chunyuNews;
};
/**
 * @description 判断当前是否在微信环境下
 * @return {Boolean} 判断结果
 */
const isFromWechat = () => {
  if (!detect.app) {
    detectApp();
  }
  return !!detect.app.wechat;
};
/**
 * @description 判断当前是否在微博环境下
 * @return {Boolean} 判断结果
 */
const isFromWeibo = () => {
  if (!detect.app) {
    detectApp();
  }
  return !!detect.app.weibo;
};
/**
 * @description 判断当前APP版本是否大于等于某个版本
 * @param {String} appVersion 被比较的APP版本
 * @param {Boolean} includeEqual 是否包含等于关系(true - 判断大于等于，false - 判断大于)
 * @return {Boolean} 判断结果
 */
const isGreaterAppVersion = (appVersion, includeEqual) => {
  if (!detect.app) {
    detectApp();
  }
  if (!detect.app.chunyuApp) {
    return false;
  }
  const currentVersions = detect.app.chunyuApp.split('.');
  const appVersions = appVersion.split('.');
  const len = Math.min(currentVersions.length, appVersions.length);

  let result = null;
  for (let i = 0; i < len; i++) {
    const curNumber = Number(currentVersions[i]);
    const appNumber = Number(appVersions[i]);

    if (curNumber > appNumber) {
      result = 1;
      break;
    } else if (curNumber < appNumber) {
      result = -1;
      break;
    } else {
      result = 0;
    }
  }

  if (includeEqual) {
    return result >= 0;
  }
  return result > 0;
};

const getVersion = () => {
  if (!detect.app) {
    detectApp();
  }
  if (!detect.app.chunyuApp) {
    return false;
  }
  const currentVersions = detect.app.chunyuApp.split('.');
  const currentLen = currentVersions.length;
  let currentV = null;

  for (let i = 0; i < currentLen; i++) {
    currentV =
      parseFloat(
        currentVersions[i][0] === 0
          ? `0.${currentVersions[i]}`
          : currentVersions[i]
      ) || 0;
    if (currentV) {
      return currentV;
    }
  }
};

/**
 * version >= 9.1.0
 * @returns {boolean} 是否使用pay v2支付
 * @author chengtingsen
 */
const isPayV2Native = () => {
  let result = false;
  if (getVersion() !== false && isGreaterAppVersion('9.1.0', true)) {
    result = true;
  }
  return result;
};

/**
 * 使用 h5 || version >= 9.1.0
 * @returns {boolean} 是否使用pay v2支付
 * @author chengtingsen
 */
const isPayV2 = () => {
  let result = false;
  if (getVersion() === false || isGreaterAppVersion('9.1.0', true)) {
    result = true;
  }
  return result;
};

/**
 * 获取pay v2 支付url
 * @param params
 * @returns {string}
 */
const getPayV2Url = (params, infoObj) => {
  if (!params || typeof params !== 'object') {
    return '';
  }

  const infoDict = encodeURIComponent(JSON.stringify(infoObj));

  const pay2Url = [
    '/weixin/pay/?',
    'pay_version=2',
    `&type=${params.order_type}`,
    `&order_type=${params.order_type}`,
    `&order_name=${params.order_name}`,
    `&order_desc=${params.order_desc || ''}`,
    `&partner=${params.partner || 'chunyu_wap'}`,
    `&return_url=${params.finish_success_url || ''}`,
    `&finish_success_url=${params.finish_success_url || ''}`,
    `&finish_fail_url=${params.finish_fail_url || ''}`,
    `&info=${infoDict}`,
  ].join('');

  return pay2Url;
};

/**
 * 跳转pay v2 支付url
 * @param params
 * @returns {boolean}
 */
const jumpV2Page = (params, infoObj) => {
  const url = getPayV2Url(params, infoObj);
  if (url) {
    window.location.href = url;
  } else {
    return false;
  }
};
export default {
  isPayV2,
  isPayV2Native,
  getPayV2Url,
  jumpV2Page,
  isFromCYAll,
  isFromCY,
  isFromCYClinic,
  isFromCYNews,
  isFromWechat,
  isFromWeibo,
  isGreaterAppVersion,
};
